import ApplicationConf from 'conf/ApplicationConf'
import { genericPromise2 } from 'utils/ActionUtils'
import i18n from 'simple-react-i18n'
import LogAction from 'log/actions/LogAction'
import ToastrAction from 'toastr/actions/ToastrAction'
import {
    RECEIVE_OPERATION_COVERS,
    RECEIVE_OPERATION_SAMPLES,
    RECEIVE_ALL_OPERATION_SAMPLES,
    RECEIVE_ALL_OPERATION_COVERS,
} from 'quality/components/operation/constants/OperationConstants'
import WaitAction from '../../wait/WaitAction'

const HydrobioAction = {
    createHydrobioList: (qualitometer, operation, hydrobioList) => (dispatch) => genericPromise2(ApplicationConf.qualitometer.hydrobioLists(qualitometer, operation), { method: 'POST', body: hydrobioList })
        .then(res => {
            if (res.insert > 0) {
                dispatch(ToastrAction.success(i18n.elementCreateSuccess))
            } else {
                dispatch(ToastrAction.error(i18n.createError + i18n.enumeration))
            }
            return res
        })
        .catch((err) => {
            dispatch(LogAction.logError(`${i18n.updateError + i18n.operations} : ${err}`))
            dispatch(ToastrAction.error(i18n.updateError + i18n.operations))
        }),
    createAllHydrobioList: (qualitometer, operation, hydrobioLists) => (dispatch) => genericPromise2(ApplicationConf.qualitometer.allHydrobioList(qualitometer, operation), { method: 'POST', body: hydrobioLists })
        .catch((err) => {
            dispatch(LogAction.logError(`${i18n.updateError + i18n.operations} : ${err}`))
            dispatch(ToastrAction.error(i18n.updateError + i18n.operations))
        }),
    updateHydrobioList: (qualitometer, operation, list, hydrobioList) => (dispatch) => genericPromise2(ApplicationConf.qualitometer.hydrobioList(qualitometer, operation, list), { method: 'PUT', body: hydrobioList })
        .then(res => {
            if (res.update > 0) {
                dispatch(ToastrAction.success(i18n.elementUpdateSuccess))
            } else {
                dispatch(ToastrAction.error(i18n.updateError + i18n.enumeration))
            }
            return res
        })
        .catch((err) => {
            dispatch(LogAction.logError(`${i18n.updateError + i18n.operations} : ${err}`))
            dispatch(ToastrAction.error(i18n.updateError + i18n.operations))
        }),
    deleteHydrobioList: (qualitometer, operation, list) => (dispatch) => genericPromise2(ApplicationConf.qualitometer.hydrobioList(qualitometer, operation, list), { method: 'DELETE' })
        .then(res => {
            if (res.delete > 0) {
                dispatch(ToastrAction.success(i18n.elementDeleteSuccess))
            } else {
                dispatch(ToastrAction.error(i18n.deleteError + i18n.enumeration))
            }
            return res
        })
        .catch((err) => {
            dispatch(LogAction.logError(`${i18n.updateError + i18n.operations} : ${err}`))
            dispatch(ToastrAction.error(i18n.updateError + i18n.operations))
        }),

    fetchHydrobioPoches: (qualitometer, operation) => (dispatch) => genericPromise2(ApplicationConf.qualitometer.hydrobioPoches(qualitometer, operation))
        .catch((err) => {
            dispatch(LogAction.logError(`${i18n.fetchError + i18n.operations} : ${err}`))
            dispatch(ToastrAction.error(i18n.fetchError + i18n.operations))
        }),
    updateHydrobioPoche: (qualitometer, operation, poche) => (dispatch) => genericPromise2(ApplicationConf.qualitometer.hydrobioPoches(qualitometer, operation), { method: 'PUT', body: poche })
        .then(res => {
            if (res?.update > 0) {
                dispatch(ToastrAction.success(i18n.elementUpdateSuccess))
            } else {
                dispatch(ToastrAction.error(i18n.updateError + i18n.enumeration))
            }
        })
        .catch((err) => {
            dispatch(LogAction.logError(`${i18n.updateError + i18n.operations} : ${err}`))
            dispatch(ToastrAction.error(i18n.updateError + i18n.operations))
        }),
    deleteHydrobioPoche: (qualitometer, operation, taxon, sampling) => (dispatch) => genericPromise2(ApplicationConf.qualitometer.hydrobioPoche(qualitometer, operation, taxon, sampling), { method: 'DELETE' })
        .then(res => {
            if (res?.delete > 0) {
                dispatch(ToastrAction.success(i18n.elementDeleteSuccess))
            } else {
                dispatch(ToastrAction.error(i18n.deleteError + i18n.enumeration))
            }
        })
        .catch((err) => {
            dispatch(LogAction.logError(`${i18n.deleteError + i18n.operations} : ${err}`))
            dispatch(ToastrAction.error(i18n.deleteError + i18n.operations))
        }),
    importHydrobioPoche: (qualitometer, operation, poche) => (dispatch) => genericPromise2(ApplicationConf.qualitometer.hydrobioPochesImport(qualitometer, operation), { method: 'POST', body: poche })
        .catch((err) => {
            dispatch(LogAction.logError(`${i18n.importError + i18n.operations} : ${err}`))
            dispatch(ToastrAction.error(i18n.importError + i18n.operations))
        })
        .then(res => {
            if (res?.import >= 0) {
                dispatch(ToastrAction.success(i18n.importSuccess))
            } else {
                dispatch(ToastrAction.error(i18n.importError))
            }
            dispatch(WaitAction.waitStop())
        }),

    fetchAllOperationSamples: (qualitometerId) => (dispatch) => genericPromise2(ApplicationConf.qualitometer.allHydrobioOperationSample(qualitometerId))
        .then((res = []) => {
            dispatch({ type: RECEIVE_ALL_OPERATION_SAMPLES, payload: res })
            return res
        })
        .catch((err) => {
            dispatch(LogAction.logError(`${i18n.fetchError + i18n.samples} : ${err}`))
            dispatch(ToastrAction.error(i18n.fetchError + i18n.samples))
        }),
    fetchOperationSamples: (qualitometerId, operationId) => (dispatch) => genericPromise2(ApplicationConf.qualitometer.hydrobioOperationSamples(qualitometerId, operationId))
        .then((res = []) => {
            dispatch({ type: RECEIVE_OPERATION_SAMPLES, payload: res })
            return res
        })
        .catch((err) => {
            dispatch(LogAction.logError(`${i18n.fetchError + i18n.samples} : ${err}`))
            dispatch(ToastrAction.error(i18n.fetchError + i18n.samples))
        }),
    createOperationSample: (qualitometerId, operationId, operationSample) => (dispatch) => genericPromise2(ApplicationConf.qualitometer.hydrobioOperationSamples(qualitometerId, operationId), { method: 'POST', body: operationSample })
        .catch((err) => {
            dispatch(LogAction.logError(`${i18n.createError + i18n.samples} : ${err}`))
            dispatch(ToastrAction.error(i18n.createError + i18n.samples))
        }),
    updateOperationSample: (qualitometerId, operationId, operationSample) => (dispatch) => genericPromise2(ApplicationConf.qualitometer.hydrobioOperationSamples(qualitometerId, operationId), { method: 'PUT', body: operationSample })
        .catch((err) => {
            dispatch(LogAction.logError(`${i18n.updateError + i18n.samples} : ${err}`))
            dispatch(ToastrAction.error(i18n.updateError + i18n.samples))
        }),
    deleteOperationSample: (qualitometerId, operationId, id) => (dispatch) => genericPromise2(ApplicationConf.qualitometer.hydrobioOperationSample(qualitometerId, operationId, id), { method: 'DELETE' })
        .catch((err) => {
            dispatch(LogAction.logError(`${i18n.deleteError + i18n.samples} : ${err}`))
            dispatch(ToastrAction.error(i18n.deleteError + i18n.samples))
        }),

    fetchAllOperationCovers: (qualitometerId) => (dispatch) => genericPromise2(ApplicationConf.qualitometer.allHydrobioOperationCover(qualitometerId))
        .then((res = []) => {
            dispatch({ type: RECEIVE_ALL_OPERATION_COVERS, payload: res })
            return res
        })
        .catch((err) => {
            dispatch(LogAction.logError(`${i18n.fetchError + i18n.covers} : ${err}`))
            dispatch(ToastrAction.error(i18n.fetchError + i18n.covers))
        }),
    fetchOperationCovers: (qualitometerId, operationId) => (dispatch) => genericPromise2(ApplicationConf.qualitometer.hydrobioOperationCover(qualitometerId, operationId))
        .then((res = []) => {
            dispatch({ type: RECEIVE_OPERATION_COVERS, payload: res })
            return res
        })
        .catch((err) => {
            dispatch(LogAction.logError(`${i18n.fetchError + i18n.covers} : ${err}`))
            dispatch(ToastrAction.error(i18n.fetchError + i18n.covers))
        }),
    createOperationCover: (qualitometerId, operationId, operationCover) => (dispatch) => genericPromise2(ApplicationConf.qualitometer.hydrobioOperationCover(qualitometerId, operationId), { method: 'POST', body: operationCover })
        .catch((err) => {
            dispatch(LogAction.logError(`${i18n.createError + i18n.covers} : ${err}`))
            dispatch(ToastrAction.error(i18n.createError + i18n.covers))
        }),
    updateOperationCover: (qualitometerId, operationId, operationCover) => (dispatch) => genericPromise2(ApplicationConf.qualitometer.hydrobioOperationCover(qualitometerId, operationId), { method: 'PUT', body: operationCover })
        .catch((err) => {
            dispatch(LogAction.logError(`${i18n.updateError + i18n.covers} : ${err}`))
            dispatch(ToastrAction.error(i18n.updateError + i18n.covers))
        }),
    deleteOperationCover: (qualitometerId, operationId) => (dispatch) => genericPromise2(ApplicationConf.qualitometer.hydrobioOperationCover(qualitometerId, operationId), { method: 'DELETE' })
        .catch((err) => {
            dispatch(LogAction.logError(`${i18n.deleteError + i18n.covers} : ${err}`))
            dispatch(ToastrAction.error(i18n.deleteError + i18n.covers))
        }),
}

export default HydrobioAction